import {
	RESET_STATE,
	SET_IS_TRAILER_TYPES_LOADING,
	SET_IS_TRAILERS_LIST_LOADING,
	SET_PAGINATION,
	SET_TABLE_SEARCH,
	SET_TRAILER_TYPES,
	SET_TRAILERS_LIST,
	SET_IS_DOWNLOAD_LOADING,
} from './actions';

export const initialState = {
	trailersList: null,
	isTrailersListLoading: true, // если тут false, loader не устанавливается
	isDownloadLoading: false,
	pagination: null,
	tableSearch: '',
	trailerTypes: null,
	isTrailerTypesLoading: false,
};

const trailersContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_TRAILERS_LIST:
			return {
				...state,
				trailersList: payload,
			};
		case SET_IS_TRAILERS_LIST_LOADING:
			return {
				...state,
				isTrailersListLoading: payload,
			};
		case SET_IS_DOWNLOAD_LOADING:
			return {
				...state,
				isDownloadLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_TABLE_SEARCH:
			return {
				...state,
				tableSearch: payload,
			};
		case SET_TRAILER_TYPES:
			return {
				...state,
				trailerTypes: payload,
			};
		case SET_IS_TRAILER_TYPES_LOADING:
			return {
				...state,
				isTrailerTypesLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default trailersContainerReducer;
